module.exports = __webpack_public_path__ + "img/fund.ed32c27a.png";